import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@env/environment';
import { SecurityService } from 'app/services/security.service';
import { toast } from 'ngx-sonner';

@Component({
  selector: 'app-desktop-message',
  imports: [
    CommonModule
  ],
  templateUrl: './desktop-message.component.html',
  styleUrl: './desktop-message.component.css'
})
export class DesktopMessageComponent implements OnInit {

  consultor = signal<any>(null);
  urlShared = environment.serverUrl;
  internalCode: string = '';

  _securityService = inject(SecurityService);
  _router = inject(Router);
  path = '';

  constructor() {
  }

  ngOnInit(): void {
    this.consultor.set({
      phone: localStorage.getItem('phone'),
      name: localStorage.getItem('consultorName'),
      user: localStorage.getItem('consultor'),
      qrImage: localStorage.getItem('qr'),
    })
    if(!this.consultor()?.qrImage){
      this.internalCode = this._router.url.split('/')[2] || '';
      this._securityService.setConsultor(this.internalCode).subscribe({
        next: (response: any) => {
          this.consultor.set({
            phone: localStorage.getItem('phone'),
            name: localStorage.getItem('consultorName'),
            user: localStorage.getItem('consultor'),
            qrImage: localStorage.getItem('qr'),
          })
        },
        error: (error) => {
          console.error('Error loading consultor by internal code:', error);
        }
      });
    }
    this.path = `${'https://vinculate.fincomercio.com/'}consultor/${ this.consultor()?.user ? this.consultor()?.user : this.internalCode }`;
  }
}
